module.exports = __webpack_public_path__ + "img/banner-advert-page-vertical.fcca6fa8.jpg";